import React, { useEffect, useState } from 'react';

import { ReactComponent as LeftArrow } from '@assets/icons/leftArrow.svg';
import { ReactComponent as RightArrow } from '@assets/icons/rightArrow.svg';

import CommonImage from '@components/CommonImage';

const ProductSlider = ({ presentationWiseImages = [], onClick, designDocuments = [] }) => {
	const [imageList, setImageList] = useState([]);
	const [selectedImage, setSelectedImage] = useState(null);

	useEffect(() => {
		if (presentationWiseImages.length > 0 || designDocuments?.length > 0) {
			let mergedImages = [];
			presentationWiseImages.forEach((image) => {
				mergedImages = [...mergedImages, ...image.documentResponse];
			});
			let filteredImages = mergedImages.filter((img) => img?.docType === 'FRONT_IMAGE');
			let featureImage = designDocuments.find((doc) => doc?.docType === 'PRODUCT_DESIGN');
			if (featureImage) {
				const isFeatureImageExist = filteredImages.find((img) => img.name === featureImage.name);
				if (!isFeatureImageExist) {
					filteredImages = [featureImage, ...filteredImages];
				}
			}
			setImageList(filteredImages);
			setSelectedImage(filteredImages[0]);
		} else {
			setImageList([]);
			setSelectedImage(null);
		}
	}, [presentationWiseImages, designDocuments]);

	const handleNext = () => {
		const selectedIndex = imageList.findIndex((img) => img.id === selectedImage.id);
		const nextIndex = selectedIndex < imageList.length - 1 ? selectedIndex + 1 : 0;
		setSelectedImage(imageList[nextIndex]);
	};

	const handlePrev = () => {
		const selectedIndex = imageList.findIndex((img) => img.id === selectedImage.id);
		if (selectedIndex > 0) {
			setSelectedImage(imageList[selectedIndex - 1]);
		}
	};

	return (
		<>
			<div className="card-product-slider">
				<CommonImage
					src={selectedImage?.docUrl || '/images/default_product.svg'}
					className="card-image"
					alt="product-image"
					isStatic={!selectedImage?.docUrl}
					onClick={onClick}
				/>
				{imageList?.length > 1 && (
					<div className="slider-arrow">
						<span className="arrow left-arrow cursor-pointer" onClick={handlePrev}>
							<LeftArrow width={28} height={28} />
						</span>
						<span className="arrow right-arrow cursor-pointer" onClick={handleNext}>
							<RightArrow width={28} height={28} />
						</span>
					</div>
				)}
			</div>
		</>
	);
};

export default ProductSlider;
